import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';

import thunkMiddleware from 'redux-thunk';
import ReduxApp from './reducers';

// @ts-ignore
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunkMiddleware];

if (process.env.NODE_ENV === 'development') {
  const loggerMiddleware = createLogger();
  middleware.push(loggerMiddleware);
}

const enhancer = applyMiddleware(...middleware);

export const store = createStore(ReduxApp, composeEnhancer(enhancer));



/** WEBPACK FOOTER **
 ** ./src/redux/store.js
 **/